import { fetchHealthBreakdownDataByEventLevelId } from '../routines/healthRoutines';

const initialState = {
  isLoading: false,
  isSuccess: false,
  health: {},
  healthB: {},
  lastCacheTime: new Date().getTime(),
};

const healthBreakdownReducer = (state = initialState, action) => {
  switch (action.type) {
    case fetchHealthBreakdownDataByEventLevelId.TRIGGER:
      return {
        ...state,
        isLoading: true,
        isSuccess: false,
      };

    case fetchHealthBreakdownDataByEventLevelId.SUCCESS: {
      const { level } = action.payload;
      return {
        ...state,
        isLoading: false,
        isSuccess: true,
        healthB: {
          ...state.healthB,
          [level]: {
            ...state.healthB[level],
            [action.payload.entityId]: {
              ...action.payload.healthB,
              lastCacheTime: action.payload.lastCacheTime,
            },
          },
        },
        lastCacheTime: action.payload.lastCacheTime,
      };
    }

    case fetchHealthBreakdownDataByEventLevelId.FAILURE:
      return {
        ...state,
        isLoading: false,
        isSuccess: false,
      };

    default:
      return state;
  }
};

export default healthBreakdownReducer;
